module.exports = __webpack_public_path__ + "img/help_yellow.acff2d5b.svg";